"use client";

import { Button } from '@/_ui/primitives';
import { ENV } from '@/lib/env';
import { getCookie, setCookie } from '@ui/lib/utils/cookies';
import Script from 'next/script';
import { useEffect, useState } from 'react';

const CONSENT_COOKIE_NAME = 'user_consent';
const CONSENT_DURATION_DAYS = 365;

export interface ConsentManagerProps {
  gaId: string;
  translations: {
    consentMessage: string;
    acceptCookies: string;
  };
}

export const ConsentManager = ({ gaId, translations }: ConsentManagerProps) => {
  // const updateGtagConsent = (status: 'granted') => {
  //   if (typeof window !== 'undefined' && (window as any).gtag) {
  //     (window as any).gtag('consent', 'update', {
  //       'ad_storage': status,
  //       'ad_user_data': status,
  //       'ad_personalization': status,
  //       'analytics_storage': status,
  //       'functionality_storage': status
  //     });
  //   }
  // };

  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (getCookie(CONSENT_COOKIE_NAME) !== 'granted') {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    setCookie(CONSENT_COOKIE_NAME, 'granted', CONSENT_DURATION_DAYS);
    // updateGtagConsent('granted');
    setShowBanner(false);
  };

  if (showBanner) {
    return (
      <div className="fixed bottom-0 z-50 w-full border-t-2  border-gray-200 shadow-lg">
        <div className="bg-white text-black p-4 text-center">
          <p>{translations.consentMessage}</p>
          <Button onClick={handleAccept} variant="secondary">{translations.acceptCookies}</Button>
        </div>
      </div>
    );
  }

  return (
    ENV.IS_PRODUCTION_MODE ? <>
      <Script
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
      />
      <Script
        id="gtag-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('consent', 'default', {
        'ad_storage': 'granted',
        'ad_user_data': 'granted',
        'ad_personalization': 'granted',
        'analytics_storage': 'granted',
        'functionality_storage': 'granted',
        'personalization_storage': 'granted',
        'security_storage': 'granted'
      });
      gtag('config', '${gaId}', {
        page_path: window.location.pathname,
      });
    `,
        }}
      />
      <Script
        async
        strategy="afterInteractive"
        src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ENV.GA_ADSENSE_ID}`}
        crossOrigin="anonymous"
      />
    </> : <></>
  );
};
